import * as React from 'react';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import Box from '@mui/material/Box';
import styled from 'styled-components';
import { CheckIcon, CopyIcon } from 'src/assets/icons';
import { IconButton } from 'src/components/atoms';
import { useCopyToClipboard } from 'src/hooks';
import { StyledLabel } from '../common';

const StyledCopyLabel = styled(StyledLabel)`
  // ellipsis
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
interface CopyTextCellContentProps {
  value: string;
  displayValue?: boolean;
}
export const CopyTextCellContent: React.FunctionComponent<CopyTextCellContentProps> = ({
  value,
  displayValue = false,
}: CopyTextCellContentProps) => {
  const { handleCopy, copied } = useCopyToClipboard({ value: value || '' });
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {isEmpty(value) ? null : (
        <>
          {displayValue ? <StyledCopyLabel>{value}</StyledCopyLabel> : null}
          <IconButton onClick={value ? handleCopy : noop} size="small">
            {copied ? <CheckIcon size={20} /> : <CopyIcon size={20} />}
          </IconButton>
        </>
      )}
    </Box>
  );
};
